import {
  Box,
  Container,
  List,
  ListItem,
  Typography,
} from "@mui/material";

import FamilyGroup from "../../assets/Membership/Family2.png";

const HeroMembresia = () => {
  const items = [
    {
      text: "Salud de calidad al alcance de todos",
      subtitle:"Con la finalidad de cuidar de tu salud y tu economía Centro Quirúrgico San Rafael ha creado la Membresía Salud365 con acceso a grandes beneficios como descuentos y precios preferenciales en servicios de salud."
    },
    {
      text: "¡Atención con calidad y calidez las 24 horas!",
      subtitle:"Con tu membresía tendras atención médica de calidad y con calidez las 24 horas, con acceso a equipo médico con tecnología de punta."
    }
  ];

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        margin: "12px 0",
        padding: "0px 16px",
        overflow: "visible",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          pl: 0,
          pr: 0,
        }}
      >
        <Box sx={{
          flexDirection: {xs: "column", md:"row"},
          justifyContent: "center",
          display: "flex",
        }}>

          <Box sx={{
            flexDirection: "column",
            justifyContent: "center",
            width: {xs: "100%", lg:"60%"},
            placeSelf: "center",
          }}>
            <List>
            {items?.map((item, index) => (
              <ListItem key={index} sx={{ 
                  display: "block",
                  width: {xs: "100%", md:"80%"},
              }}>

                <Typography
                sx={{
                  fontSize: "20px",
                  lineHeight: 1.235,
                  textAlign: "left",
                  color: "rgb(25, 91, 224)",
                  fontWeight: 700,
                }}>
                  {item.text}
                </Typography>

                <Typography sx={{
                  margin: "8px 0px 0px",
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: 1.6,
                  color: "rgb(24, 36, 107)",
                  textAlign: "justify",
                }}>
                  {item.subtitle}
                </Typography>
                
              </ListItem>
            ))}
            </List>
          </Box>

          <Box sx={{
            width: {xs: "100%", lg: "40%"},
          }}>
            <Box
              component="img"
              src={FamilyGroup}
              alt="hero_salud360"
              loading="lazy"
              sx={{
                width: "100%",
                objectFit: "fill",
                maskImage: "linear-gradient(to right, #5FC646 55%, transparent 75%)",
              }}
            />
          </Box>

        </Box>
      </Container>
    </Box>
  );
};

export default HeroMembresia;